<template>
  <div class="is-fullwidth mt-6 mb-6" style="background-color: #2F2F2F">
    <h1 class="title is-3 has-text-white has-text-centered pt-6">Skills</h1>
    <div class="container pt-4">
      <div class="columns mt-3 pb-6 has-text-centered">
        <div class="column">
          <img src="../assets/html.png" class="is-32x32"/>
        </div>
        <div class="column">
          <img src="../assets/css.png" class="is-32x32"/>
        </div>
        <div class="column">
          <img src="../assets/laravel.png" class="is-32x32"/>
        </div>
        <div class="column">
          <img src="../assets/react.png" class="is-32x32"/>
        </div>
        <div class="column">
          <img src="../assets/php.svg" class="is-32x32"/>
        </div>
        <div class="column">
          <img src="../assets/python.png" class="is-32x32"/>
        </div>
        <div class="column">
          <img src="../assets/node-logo.png" class="is-32x32"/>
        </div>
        <div class="column">
          <img src="../assets/logo.png" class="is-32x32"/>
        </div>
        <div class="column ">
          <img src="../assets/jquery.png" class="is-32x32"/>
        </div>
        <div class="column">
          <img src="../assets/git.png" class="is-32x32"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Skill"
}
</script>

<style scoped>
@media only screen and (max-width: 768px){
  img{
    width: 20%
  }
}
</style>
